<template>
  <div class="d-lg-flex align-items-lg-center d-flex align-items-center mb-lg-0 mb-2">
    <!-- <BButton class="mr-4" variant="light" @click="$emit('action')">
      <i class="fas fa-ellipsis-v"></i>
    </BButton> -->
    <BButton v-if="filter" class="d-lg-flex d-flex align-items-center align-items-lg-center mr-2 mb-lg-0" variant="light" @click="$emit('showFilter')">
      <i class="fas fa-filter mr-2"></i>
      Filter
    </BButton>
    <BInputGroup class="mr-lg-2 mr-0 border rounded-lg">
      <template #append>
        <BButton variant=""><i class="ios ion-ios-search text-black"></i></BButton>
      </template>
      
      <BFormInput type="text" class="border-0" placeholder="Search">
  
      </BFormInput>
    </BInputGroup>
  </div>
</template>

<script>
import { 
  // BButtonGroup, 
  BInputGroup,
  BButton, 
  BFormInput } from 'bootstrap-vue-next';

export default {
  name: 'FilterSearch',
  components: {
    // BButtonGroup,
    BInputGroup,
    BButton,
    BFormInput
  },
  props: {
    filter: {
      type: Boolean,
      default: true,
    },
  }

}
</script>

<style>

</style>